import s from './Button.module.scss';
import cn from 'classnames';

type ButtonProps = {
  variant: 'primary' | 'secondary';
  text: string;
  component?: 'button' | 'a';
  href?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
};

export function Button({ variant, text, component = 'button', href, icon, onClick }: ButtonProps) {

  if (component === 'a') {
    return (
      <a className={cn(s.root, s[variant])} href={href} onClick={onClick} target="_blank" rel="noopener noreferrer">
        {icon}
        <p>{text}</p>
      </a>
    );
  }

  return (
    <div className={cn(s.root, s[variant])} onClick={onClick}>
      {icon}
      <p>{text}</p>
    </div>
  );
}
